import { OutlinedInput } from "@mui/material";
import { ReactElement } from "react";
import styled from "styled-components";

import { PIC } from "@ryde/assets";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  blueMui,
  greyMui,
  purpleMui,
  redMui,
  rydeColors,
} from "@ryde/theme";

export const FilterSearchStyled = styled(
  OutlinedInput,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "filter-search-styled",
})`
  font-size: 14px;
  color: ${blueGreyMui._400};

  &.MuiOutlinedInput-root {
    padding-inline-end: 8px;
    padding-inline-start: 12px;
  }

  &.Mui-error {
    background-color: ${rydeColors.searchFilterFieldBackgroundError};
  }

  & .MuiInputAdornment-root {
    color: ${blueGreyMui._400};
  }

  & .MuiInputAdornment-positionStart {
    margin-inline-end: 0;
  }

  & .MuiOutlinedInput-input {
    padding-inline: 0;
    padding-block: 4px;
    height: 26px;
    margin-inline: 3px;
    margin-inline-start: 0;
    color: ${rydeColors.black};

    &::placeholder {
      color: ${blueGreyMui._400};
      opacity: 1;
    }
  }

  & .MuiOutlinedInput-notchedOutline {
    border-color: ${greyMui._300};
    border-width: 1px;
  }

  &:hover:not(.Mui-error):not(.filter-border__suspended)
    .MuiOutlinedInput-notchedOutline {
    border-color: ${purpleMui._500};
  }

  &.filter-border__suspended {
    .MuiOutlinedInput-notchedOutline {
      border-color: ${redMui._700};
    }

    &:hover .MuiOutlinedInput-notchedOutline,
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${redMui._700};
    }
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }

  &.filter-border__highlighted {
    &:not(.Mui-focused):not(.Mui-error) {
      border-radius: 4px;
      outline: 1px solid ${blueMui._300};
      box-shadow: 2px 2px 5px rgba(2, 136, 209, 0.25);
      &.filter-search_border-highlighted:not(.Mui-focused):not(.Mui-error) {
        border-radius: 4px;
        outline: 1px solid ${blueMui._300};
        box-shadow: 2px 2px 5px rgba(2, 136, 209, 0.25);
      }
    }
  }

  &.filter-border__suspended {
    border-radius: 4px;
    &:hover {
      box-shadow: 2px 2px 5px rgba(255, 0, 0, 0.25);
    }
    svg {
      color: ${redMui._700};
    }

    input.MuiOutlinedInput-input {
      color: ${redMui._400};
      &::placeholder {
        color: ${redMui._300};
      }
    }
    &.filter-search_border-highlighted:not(.Mui-focused):not(.Mui-error) {
      border-radius: 4px;
      outline: 1px solid ${blueMui._300};
      box-shadow: 2px 2px 5px rgba(2, 136, 209, 0.25);
    }
  }
`;

export const FilterSearchSearchClearIcon = (): ReactElement => (
  <PIC.XSVG width={11} height={11} data-e2e="search-clear-icon-svg" />
);
